var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 16h2V7.643h3L12 3 8 7.643h3V16z",
    fill: "#A7A7A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.778 21h12.444c.98 0 1.778-.828 1.778-1.846v-8.308C20 9.828 19.203 9 18.222 9h-3.555v1.846h3.555v8.308H5.778v-8.308h3.555V9H5.778C4.798 9 4 9.828 4 10.846v8.308C4 20.172 4.797 21 5.778 21z",
    fill: "#A7A7A7"
  })));
}
export default SvgExport;